export default function WelcomePage() {

  return (
    <div>
      <h2 className="mb-2">Bienvenido</h2>
      <p className="text-muted mb-4">Selecciona un módulo</p>
    </div>
  );
}